import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import AllSectorsHero from "../../components/pages/AllSectors/AllSectorsHero/AllSectorsHero";
import AllSectorsSectors from "../../components/pages/AllSectors/AllSectorsSectors/AllSectorsSectors";
import AllSolutionsRequestNewProject from "../../components/pages/AllSolutions/AllSolutionsRequestNewProject/AllSolutionsRequestNewProject";
import { getPublicSectors } from "../../api/sectors";
import { getPageContent } from "../../api/content";
import { findPageSection, unwrapSectionData } from "../../utils/aboutStartNewProjectSection";

const AllSectors = () => {
  const { i18n } = useTranslation();
  const [sectors, setSectors] = useState([]);
  const [pageContent, setPageContent] = useState({});

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      const language = String(i18n.language || "en").toLowerCase();

      const sectorsPromise = getPublicSectors(language).catch(() => []);

      const pageAliases = ["allsectors", "all-sectors", "sectors", "allsector"];
      let sectorsPageData = {};
      for (const page of pageAliases) {
        try {
          const data = await getPageContent({ page, language });
          if (data && typeof data === "object" && Object.keys(data).length) {
            sectorsPageData = data;
            break;
          }
        } catch {
          // try next alias
        }
      }

      const sectorsList = await sectorsPromise;
      if (!isMounted) return;
      setSectors(Array.isArray(sectorsList) ? sectorsList : []);
      setPageContent(sectorsPageData);
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  const heroSection =
    findPageSection(pageContent, "hero") ||
    findPageSection(pageContent, "allsectorshero") ||
    findPageSection(pageContent, "allsectors");

  return (
      <div className="sectors-page">
        <Navbar theme="light" />
        <AllSectorsHero content={unwrapSectionData(heroSection)} />
        <div className="sectors-page-content-guide">
          <div id="sectors-explore">
            <AllSectorsSectors sectors={sectors} />
          </div>
          <AllSolutionsRequestNewProject />
        </div>
        <Footer />
      </div>
  );
};

export default AllSectors;
